<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="出库单号">
          <el-input placeholder="请输入出库单号" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button  size="small" v-if="showBack" type="info" @click="gotoBack">返回上一页</el-button>
        </el-form-item>

      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick"
      v-auth="'/plus/out_management/index/add'"
      >添加出库</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="order_id" label="订单ID"></el-table-column>
            <el-table-column prop="order.order_status.text" label="订单状态"></el-table-column>
            <el-table-column prop="order_umber" label="出库单号"></el-table-column>
            <el-table-column prop="totalAmount" label="金额"></el-table-column>
            <el-table-column prop="type_text" label="类型"></el-table-column>
            <el-table-column prop="status_text" label="状态"></el-table-column>
            <el-table-column prop="shop_user_text" label="发单人"></el-table-column>
            <!-- <el-table-column prop="print_status" label="打印状态">
              <template slot-scope="scope">

                <div v-if="scope.row.print_status == 0">未打印</div>
                <div v-if="scope.row.print_status == 1">已打印</div>

              </template>


            </el-table-column> -->
            <!-- <el-table-column prop="print_nums" label="打印次数"></el-table-column> -->
            <el-table-column fixed="right" label="操作" width="300">
              <template slot-scope="scope">

                <!-- <el-button @click="prClick(scope.row)"
                 
                  type="text" size="small" v-if="scope.row.status == 2">打印出库单</el-button> -->
                
                
                <span v-if="scope.row.order_id > 0">
                  <span v-if="scope.row.order.order_status.value == 10">
                    <el-button @click="ckClick(scope.row)" v-if="scope.row.status == 0 && (scope.row.type !=1)" 
                  v-auth="'/plus/out_management/index/applyck'"
                  type="text" size="small">申请出库</el-button>

                  <el-button @click="ckClick(scope.row)" v-if="scope.row.status == 3 && (scope.row.type !=1)" 
                  v-auth="'/plus/out_management/index/applyck'"
                  type="text" size="small">重新申请出库</el-button>
                  <el-button @click="editClick(scope.row)" 
                  
                    v-auth="'/plus/out_management/index/edit'"
                  v-if="scope.row.status == 0||scope.row.status == 3" type="text" size="small">编辑</el-button>
                  </span>
           
                </span>

                <span v-else>
                  <el-button @click="ckClick(scope.row)" v-if="scope.row.status == 0 && (scope.row.type !=1)" 
                  v-auth="'/plus/out_management/index/applyck'"
                  type="text" size="small">申请出库</el-button>

                  <el-button @click="ckClick(scope.row)" v-if="scope.row.status == 3  && (scope.row.type !=1)" 
                  v-auth="'/plus/out_management/index/applyck'"
                  type="text" size="small">重新申请出库</el-button>
                  <el-button @click="editClick(scope.row)" 
                  
                    v-auth="'/plus/out_management/index/edit'"
                  v-if="scope.row.status == 0||scope.row.status == 3" type="text" size="small">编辑</el-button>

                </span>
    

                <el-button @click="passClick(scope.row)"
                v-auth="'/plus/out_management/index/applyck_success'"
                type="text" size="small" v-if="scope.row.status == 1 && (scope.row.type !=1)">审核通过</el-button>
                <el-button @click="nopassClick(scope.row)"
                v-auth="'/plus/out_management/index/applyck_faild'"
                type="text" size="small" v-if="scope.row.status == 1 && (scope.row.type !=1)">审核不通过</el-button>


                <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="deleteClick(scope.row)"
                
                  v-auth="'/plus/out_management/index/del'"
                type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :out_management_id="out_management_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Detail :open_add="open_detail" :out_management_id="out_management_id"  v-if="open_detail"   @close="closeDetail"></Detail>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Out_managementApi from '@/api/out_management.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Detail from './part/detail.vue';
  export default {
    components: {
      Add,
      Edit,
      Detail,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        out_management_id:"",
        dialogVisible:false,
        open_detail:false,
        //出库状态 0 未出库 1 申请出库  2 申请出库成功  3 申请出库失败
        showBack:false,
      };
    },
    created() {
      if(this.$route.query.id && this.$route.query.id > 0){
        this.showBack = true;
        this.formInline.search = this.$route.query.id
      }
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*返回上一页面*/
      gotoBack(){
        this.$router.back(-1);
      },
      prClick(item){
        let self = this;
        this.$router.push({
                path: '/plus/out_management/index/print',
                query: {
                  id: item.out_management_id
                }
            });
  
      },
      detailClick(row){
        /*编辑活动*/
      this.out_management_id = row.out_management_id;
      this.open_detail = true
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//出库标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closeDetail(e){
      this.open_detail=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Out_managementApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.out_management_id = row.out_management_id;
        this.open_edit = true
      },
      ckClick(row) {
        let self = this;
        self
          .$confirm('是否申请出库，审核通过，出库之后不再支持编辑，是否出库?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Out_managementApi.ck(
              {
                out_management_id: [row.out_management_id]
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '平台审核中',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Out_managementApi.del(
              {
                out_management_id: row.out_management_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        out_management_id:item.out_management_id,
        status:2,//出库状态 0 未出库 1 申请出库  2 申请出库成功  3 申请出库失败
      }
      Out_managementApi.passCanel(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {
          
         
        });

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');

      var Params = {
        out_management_id:item.out_management_id,
        status:3,//出库状态 0 未出库 1 申请出库  2 申请出库成功  3 申请出库失败
        reject_val:reject_val
      }
      Out_managementApi.passCanel(Params, true)
        .then(data => {
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/out_management/index/index.vue